import { createSlice } from '@reduxjs/toolkit';

// types
export type UserProfileProps = {
  name: string | null;
  email: string | null;
  rank: string | null;
  role: null;
  avatar: string | null;
 organization_name:string | null;
 organization_logo: string | null;
};

// initial state
const initialState: UserProfileProps = {
  name: null,
  email: null,
  rank: null,
  role: null,
  avatar: null,
 organization_name:null,
 organization_logo: null
};

// ==============================|| SLICE - USER AUTH ||============================== //

const userprofile = createSlice({
  name: 'userprofile',
  initialState,
  reducers: {
    updateUserProfile(state, action) {
      state.name = action.payload.username;
      state.email = action.payload.email;
      state.rank = action.payload.rank;
      state.role = action.payload.roles;
      state.avatar = action.payload.avatar;
      state.organization_name = action.payload.organization_name
      state.organization_logo = action.payload.organization_logo
    }
  }
});

export default userprofile.reducer;

export const { updateUserProfile } = userprofile.actions;
